export const Logo = ({ size = 40, mono = false }) => {
  const strokeColor = mono ? "currentColor" : "#0A2A1E";
  const accent = mono ? "currentColor" : "#C6F035";
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="SconeCORE Enterprises"
    >
      {/* Compass / star mark inspired by business card */}
      <g>
        <path
          d="M32 4 L36 28 L60 32 L36 36 L32 60 L28 36 L4 32 L28 28 Z"
          fill={accent}
          stroke={strokeColor}
          strokeWidth="1.4"
          strokeLinejoin="round"
        />
        <circle cx="32" cy="32" r="4" fill={strokeColor} />
      </g>
    </svg>
  );
};

export default Logo;
